const STATIC_COMPONENT = [
  'FORM_STATIC_IMG',
  'FORM_STATIC_TEXT',
  'FORM_WIDGET_SPACE',
  'FORM_WIDGET_SPLIT'
]
const GLOBAL_EXCLUDE = [
  'FORM_DATA_STATISTICS'
]
const MESSAGE_REMIND_BUSINESS_EXCLUDE = [
  ...GLOBAL_EXCLUDE,
  ...STATIC_COMPONENT,
  'FORM_RICH_TEXT',
  'FORM_WIDGET_SPLIT',
  'FORM_ASSOCIATION',
  'FORM_WIDGET_AREA',
  'FORM_WIDGET_LOCATION'
]
const MESSAGE_REMIND_SYSTEM_EXCLUDE = [
  'FORM_DATEPICK_INPUT'
]
export default {
  STATIC_COMPONENT,
  GLOBAL_EXCLUDE,
  MESSAGE_REMIND_BUSINESS_EXCLUDE,
  MESSAGE_REMIND_SYSTEM_EXCLUDE
}
